module.exports = __webpack_public_path__ + "static/media/layout.43d623c2.svg";